export function runRoutine(routine, deps, ...args) {
    return routine._impl(deps, ...args);
}
export function runAsyncRoutine(routine, deps, ...args) {
    return routine._implAsync(deps, ...args);
}
